import { Heading4, Paragraph } from '../../../components/Text';
import { formatMoney } from '../../../utils/formatMoney';

import style from './result.module.css';

interface ResultProps {
  label: string;
  value: number;
}

const Result = ({
  label,
  value,
}: ResultProps) => {
  return (
    <div className={style.result}>
      <Paragraph fontSize={15}>
        {label}
      </Paragraph>

      <Heading4 fontSizeOverride={30}>
        {formatMoney(value)}
      </Heading4>
    </div>
  );
};

export default Result;
